import React from 'react';

import "./Info.scss";
import { Block} from '@randajan/jet-react/dom/block';
import { Img } from '@randajan/jet-react/dom/img';
import { usePop } from '@randajan/jet-react/dom/modal';


import lang from '../../config/lang';


export const Info = (props)=>{
    const { content, caption } = props;
    const pop = usePop(<Block className="Info" caption={caption}>{content}</Block>);


    
    return <Img className="Info" alt={lang.info} src="/icons/help.svg" onClick={_=>pop.up()}/>
}

